// extracted by mini-css-extract-plugin
export default {"floatingFab":"Fab_floatingFab__NSLeP"};